// extracted by mini-css-extract-plugin
export default {"selectedStationBox":"SelectedServiceHeader_selectedStationBox__IlkZE","selectedSummary":"SelectedServiceHeader_selectedSummary__1mojz"};